export const getLastSearchedPoiText = (name: string, address?: string) => {
    const addressText = address ? `: ${address}` : '';
    return `${name}${addressText}. see all searched POI’s here: `;
};
